import { Icon, Rating } from 'components';

export function GuestRankStarDisplay({ star }: { star: number }) {
  if (star === 0) {
    return <Icon icon="star" color="" />;
  }
  return <Rating value={star} isShowEmpty={false} />;
}
